import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as BookmarkProblemsActions from '../actions/bookmark-problems.actions';
import { BookmarkProblemsService } from '../services/bookmark-problems.service';
import { dispatchAppError } from '../actions/core.actions';
import { FirestoreError } from '../errors/firestore-error';
import { AppError } from '../errors/app-error';

@Injectable()
export class BookmarkProblemsEffects {
  private LOG_SOURCE = this.constructor.name;

  findBookmarkProblems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BookmarkProblemsActions.findBookmarkProblems),
      switchMap(action =>
        this.bookmarkProblemsService.findBookmarkProblems(action.userId, action.subjectIds).pipe(
          map(bookmarkProblems => BookmarkProblemsActions.findBookmarkProblemsSuccess({ bookmarkProblems })),
          catchError(e => {
            const error = e instanceof AppError ? e : FirestoreError.from(e);
            return of(BookmarkProblemsActions.findBookmarkProblemsFailure(), dispatchAppError({ source: this.LOG_SOURCE, error }));
          })
        )
      )
    )
  );

  addProblem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BookmarkProblemsActions.addProblem),
      map(({ tempId, collectionData }) => {
        console.log(`${collectionData.problemId}の問題が${tempId}として追加されました`);
        return BookmarkProblemsActions.addProblemSuccess();
      })
    )
  );

  updateBookmarkProblemsId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BookmarkProblemsActions.updateBookmarkProblemsId),
      map(({ tempId, realId }) => {
        console.log(`bookmarkProblemsステートの${tempId}が${realId}に置き換えられました`);
        return BookmarkProblemsActions.updateBookmarkProblemsIdSuccess();
      })
    )
  );

  deleteProblem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BookmarkProblemsActions.deleteProblem),
      map(({ listId, problemId }) => {
        console.log(`${listId}のお気に入りリストから${problemId}の問題が削除されました: ${listId}`);
        return BookmarkProblemsActions.deleteProblemSuccess();
      })
    )
  );

  constructor(private actions$: Actions, private bookmarkProblemsService: BookmarkProblemsService) {}
}
